define ('absoluteaudio/debug',[],function() {

    var urlParams = {},
        match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    while (match = search.exec(query)) {
        urlParams[decode(match[1])] = decode(match[2]);
    }

    var Debug = {

        enabled: urlParams['debugAudio'] && urlParams['debugAudio'] === 'true'

    };

    return Debug;
});

